import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[dynamicContainer]'
})
export class DynamicContainerDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
